const normaliseValues = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (value || value === 0) return [value];
    return [];
};

const normaliseName = (value) => String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');

const singulariseLastWord = (value) => value
    .split(' ')
    .map((word) => (word.length > 3 && word.endsWith('s') ? word.slice(0, -1) : word))
    .join(' ');

const getTreatmentName = (treatment) => (
    treatment?.name
    || treatment?.treatment_item?.name
    || treatment?.treatment?.treatment_item?.name
    || ''
);

const namesMatch = (treatmentName, targetName) => {
    const name = normaliseName(treatmentName);
    const target = normaliseName(targetName);
    if (!name || !target) return false;
    if (name.includes(target) || target.includes(name)) return true;

    const singularName = singulariseLastWord(name);
    const singularTarget = singulariseLastWord(target);
    return singularName.includes(singularTarget) || singularTarget.includes(singularName);
};

export const hasWidgetTreatmentMatch = (treatments, value) => (
    resolveWidgetTreatments(treatments, value).length > 0
);

export const findWidgetTreatmentMatch = (treatments, value) => (
    resolveWidgetTreatments(treatments, value)[0] || null
);

export const resolveWidgetTreatments = (treatments, value) => {
    const values = normaliseValues(value)
        .map((val) => val?.toString?.())
        .filter(Boolean);

    if (!Array.isArray(treatments) || values.length === 0) return [];

    const matches = [];
    treatments.forEach((treatment) => {
        const treatmentName = getTreatmentName(treatment);
        if (values.some((target) => namesMatch(treatmentName, target))) {
            matches.push(treatment);
        }
    });

    return matches;
};

export default resolveWidgetTreatments;
